import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null, // Store logged-in user details
  assignedReviewers: [], // Store assigned reviewers for a control
};

const controlSlice = createSlice({
  name: "control",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setAssignedReviewers: (state, action) => {
      state.assignedReviewers = action.payload;
    },
  },
});

export const { setUser, setAssignedReviewers } = controlSlice.actions;
export default controlSlice.reducer;
